import { Button, Form, Input } from "antd";
import FormItem from "antd/es/form/FormItem";
import { SyntheticEvent } from "react";
import { usePassportStep } from "./usePassportStep";

const PassportStep: React.FC = () => {
	const form = Form.useFormInstance<SignupFormValues>();

	const { handleSearchPassport, handleClaimApplication, isSearching, isSubmitting, applicationId, defaultPassport } =
		usePassportStep();

	return (
		<div className="flex flex-col items-stretch gap-4 p-6">
			<div className="hidden md:block border-b border-solid border-gray-200 mt-2" />
			<Form.Item
				name="passport"
				label="Passport number"
				getValueFromEvent={(event: SyntheticEvent<HTMLInputElement>) => {
					event.currentTarget.value = event.currentTarget.value.toUpperCase();
					return event.currentTarget.value;
				}}
				initialValue={defaultPassport}
				required
				rules={[
					{
						required: true,
						message: "Passport number is required",
						validator: async (_, value) => {
							if (!value) return Promise.reject(new Error("Passport number is required"));
							try {
								await handleSearchPassport(value);
							} catch (error: any) {
								return Promise.reject(new Error(error?.message || "Traveller does not exist in order"));
							}
						},
						validateTrigger: ["onBlur", "onChange"]
					}
				]}>
				<Input className="text-uppercase" placeholder="X6044075" maxLength={8} />
			</Form.Item>
			<FormItem shouldUpdate>
				{() => (
					<Button
						block
						htmlType="submit"
						type="primary"
						loading={isSubmitting}
						disabled={isSearching || form.getFieldError("passport").length > 0 || !applicationId}
						onClick={handleClaimApplication}>
						Continue
					</Button>
				)}
			</FormItem>
		</div>
	);
};

export default PassportStep;

